import firebase from 'firebase/app'
import 'firebase/auth'
/* import 'firebase/firestore' */
import "firebase/analytics"
/* import "firebase/messaging" */

// import "firebase/performance";

const config = require('../credentials/ENV/prod').FIREBASE;

firebase.initializeApp(config)

const auth = firebase.auth()
const currentUser = auth.currentUser;
// const perf = firebase.performance();
let messaging = null;
const analytics = firebase.analytics();

/* if (firebase.messaging.isSupported()) {
    if (typeof window.Notification !== "undefined") {
        try {
            messaging = firebase.messaging();
            messaging.usePublicVapidKey("BA7qnL1Ro7uRHiqSwz6nl3CgOusH_Eg82mdvoaluVl0-Uj7GKrQnSwqW1d00XX_Hf3S5i0FMp9y3-TteIZMhMG0");
        } catch (err) {
            console.log('notifications error  ', err);
        }
    }
} */
export {
    auth,
    currentUser,
    firebase,
    analytics,
    messaging
}
